<template>
  <div class="b1202">
    <div class="outerBlock">
      <div class="eventBlock">
        <div :class="'event '+bgColor" :key="'event'+key" v-for="(events,key) in amountEvents()">
          <div :key="key" v-for="(event,key) in events">
            *{{event.title}}
            <Br/>
            <span :key="dk" v-for="(description,dk) in event.descriptions">
              {{description}}
              <Br/>
            </span>
            <br>
          </div>
        </div>
        <div
          :key="'event2'+key"
          class="event"
          v-for="(event,key) in result.events.filter(i=>i.seq>2)"
        >
          *{{event.title}}
          <Br/>
          <span :key="dk" v-for="(description,dk) in event.descriptions">
            <span v-if="event.hasArrow">→</span>
            {{description}}
            <Br/>
          </span>
          <br>
        </div>
      </div>
      <div class="lineBlock">
        <div class="jiezhi">{{ result.month }}月缔</div>
        <div class="d4"></div>
        <div class="shuxian"></div>
      </div>
    </div>
    <div class="bottomBlock">
      <div class="timeline">
        <ol>
          <li></li>
        </ol>
        <div class="yearMonth">{{ result.yearMonth }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['result', 'bgColor'],
  methods: {
    amountEvents() {
      return this.groupBy(this.result.events.filter(i => i.seq <= 2), function(
        item
      ) {
        return [item.seq]
      })
    },
    groupBy(array, f) {
      let groups = {}
      array.forEach(function(o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function(group) {
        return groups[group]
      })
    }
  }
}
</script>
<style scoped>
.b1202 {
  height: 100%;
}
.outerBlock {
  /* border: 1px solid red; */
  display: flex;
  height: 100%;
}

.eventBlock {
  /* border: 1px solid red; */
  width: 20%;
  margin-left: 10px;
  height: 100%;
}

.lineBlock {
  /* border: 1px solid red; */
  font-size: 10px;
  width: 80px;
  margin-left: 56%;
  height: 100%;
}

.bottomBlock {
  /* border: 1px solid red; */
  height: 18%;
  width: 30%;
}

.jiezhi {
  /* border: 1px solid red; */
  width: 60px;
  /* margin-left: 1%; */
  margin-top: -5%;
  font-size: 1.3rem;
}

.d4 {
  margin-top: -55%;
  margin-left: -5%;
  border-width: 20px;
  border-style: solid;
  border-color: transparent transparent transparent red;
  transform: rotate(-90deg); /* 顺时针旋转90° */
}

.shuxian {
  border: 2px solid red;
  background-color: red;
  width: 10px !important;
  margin-top: 10%;
  margin-left: 40%;
  height: 100%;
}

.event {
  border: 1px solid black;
  font-size: 1rem;
  width: 280px;
  word-wrap: break-word;
  margin: 5%;
  padding: 5px;
}

.timeline ol li {
  display: inline-block;
  list-style-type: none;
  width: 400%;
  margin-top: 30px;
  height: 10px;
  background: yellow;
}

.timeline ol {
  padding-left: 0px;
}

li:before {
  content: '';
  display: flex;
  width: 25px;
  height: 25px;
  margin-left: 60%;
  margin-top: -10px;
  background-color: green;
  border-radius: 50%;
}

.yearMonth {
  /* border: 1px solid green; */
  height: 20px;
  width: 80px;
  margin-left: 260px;
}
</style>